(ns ui.view.survey.modals.loading-excel
  (:require [common.localization :as loc]
            [re-frame.core :as rf]
            [ui.components.modal.view :as modal]
            [ui.view.survey.sub :as survey-view-sub]))

(defn body
  [lang]
  [:div
   {:class "flex flex-col gap-4 align-items-center py-20"}
   [:i
    {:class "fal fa-file-excel animate-spin text-[96px]"}]
   ])

(defn footer
  [lang]
  [:div
   {:class "flex flex-row flex-auto"}])

(defn view
  [survey-id]
  (let [lang @(rf/subscribe [::survey-view-sub/selected-lang survey-id])
        visible? @(rf/subscribe [::survey-view-sub/loading-excel survey-id])]
    [modal/view
     {:visible? visible?
      :size     :full}
     (loc/tr :survey-loading-excel-modal-title nil lang)
     [body lang]
     nil]))
